import { createBreakpoints } from "@chakra-ui/theme-tools"
import { theme as chakraTheme } from '@chakra-ui/react'
import { extendTheme } from "@chakra-ui/react";
import boardBackgroundImg from "../assets/images/redwood_background_dark.png"
import boardSelectorBackgroundImg from "../assets/images/board_selector_bg.png"

const fonts = {
  ...chakraTheme.fonts,
  body: `Oracle Sans, Helvetica, sans-serif`,
  heading: `Oracle Sans, Helvetica, sans-serif;`
}


const breakpoints = createBreakpoints({
  sm: "320px",
  md: "768px",
  lg: "960px",
  xl: "1200px",
})

export const theme = extendTheme({
  styles: {
    global: {
      body: {
        bg: 'gray.400',
        backgroundImage: boardBackgroundImg,
        color: 'white',
        fontFamily: 'Oracle Sans, Helvetica, sans-serif'
      },
    },
  },
  breakpoints,
  fonts
})

export const boardSelectorTheme = extendTheme({
  styles: {
    global: {
      body: {
        bg: 'gray.400',
        backgroundImage: boardSelectorBackgroundImg,
        color: 'white',
        fontFamily: 'Oracle Sans, Helvetica, sans-serif'
      },
    },
  },
  breakpoints,
  fonts
})